import { h, Fragment } from "preact";
import { useEffect, useState } from "preact/hooks";
import ProductColorCard from "./block-color-card.jsx";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";

const ProductFeature = ({ ids }) => {
  const [products, setProducts] = useState([]);

  // Get Products By ID Sets based on Props
  const getProductsByIds = async () => {
    const response = await storefront.request({
      query: queries.products,
      variables: {
        ids: ids.map((id) => encodeId(id, "Product")),
      },
    });
    if (response?.data?.nodes) {
      const products = response.data.nodes.filter((p) => p);
      setProducts(products);
    }
  };

  useEffect(() => {
    getProductsByIds();
  }, []);

  return products.map((item) => {
    return <ProductColorCard data={item} gallery={false} />;
  });
};

export default ProductFeature;
